import React, { useState } from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import { ChatInputNormalExample, ChatMessageExample } from '../../components/UISystem/Chat';
import IconBack from '../../components/UISystem/Icons/IconBack';

/**
 * UI System Chat Screen
 *
 * Displays all Chat components from the UI System
 */
const ChatScreen = ({ onBack }) => {
  const [activeComponent, setActiveComponent] = useState('chatMessage');

  const handleComponentSelect = (componentName) => {
    setActiveComponent(componentName);
  };

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'chatInputNormal':
        return <ChatInputNormalExample />;
      case 'chatMessage':
        return <ChatMessageExample />;
      default:
        return <ChatMessageExample />;
    }
  };

  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        {/* Back button */}
        <button onClick={onBack} style={UI_SCREEN_STYLES.backButton}>
          <IconBack />
        </button>

        {/* Title */}
        <h1 style={UI_SCREEN_STYLES.title}>Chat</h1>
      </div>

      {/* Divider */}
      <div style={UI_SCREEN_STYLES.divider}></div>

      {/* Component Selection */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '10px 0',
          borderBottom: '1px solid #eee',
        }}
      >
        <div
          style={{
            display: 'flex',
            overflowX: 'auto',
            maxWidth: '100%',
            padding: '0 10px',
          }}
        >
          <button
            onClick={() => handleComponentSelect('chatMessage')}
            style={{
              padding: '8px 12px',
              margin: '0 5px',
              backgroundColor: activeComponent === 'chatMessage' ? '#0084ff' : '#f0f0f0',
              color: activeComponent === 'chatMessage' ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            ChatMessage
          </button>
          <button
            onClick={() => handleComponentSelect('chatInputNormal')}
            style={{
              padding: '8px 12px',
              margin: '0 5px',
              backgroundColor: activeComponent === 'chatInputNormal' ? '#0084ff' : '#f0f0f0',
              color: activeComponent === 'chatInputNormal' ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            ChatInputNormal
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        {/* Wrapper to constrain width for chat components */}
        <div
          style={{
            maxWidth: '390px',
            margin: '0 auto',
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default ChatScreen;
